import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';

@Component({
    selector: 'asset-inspection-status-chip',
    templateUrl: './asset-inspection-status-chip.component.html',
    styleUrls: ['./asset-inspection-status-chip.component.scss'],
    standalone: true
})

export class AssetInspectionStatusChipComponent implements OnInit {

  @Input({required: true}) status!: string;

  toClass() {
    return this.status ? _.toLower(this.status.replace(/\s/g, '')) : '';
  }

  constructor() {
  }

  ngOnInit(): void {
  }

}
